export default __webpack_public_path__ + "static/img1-6225674ef7bb5d443249a0c5f0cc3b58.jpg";